import { render } from "./table-denounces.vue?vue&type=template&id=d13385ca&ts=true"
import script from "./table-denounces.vue?vue&type=script&lang=ts"
export * from "./table-denounces.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__